export function logoUrl(empresa) {
  if (!empresa?.logo_url) return null;
  const base = process.env.REACT_APP_BACKEND_URL || "";
  return `${base}${empresa.logo_url}`;
}
